import React from "react"
import styles from "./TSNWebsiteLink.module.scss"
import {useTranslation} from "react-i18next"

export const TSNWebsiteLink: React.FC = () => {
    const {t} = useTranslation(["auth_portal"])

    return (
        <div className={styles.tsn}>
            <span className={styles.text}>{t("auth_portal:auth_page.more_info")}</span>
            <a href="https://www.tsnvcs.com" target={"_blank"} rel="noreferrer">
                www.tsnvcs.com
            </a>
        </div>
    )
}
